import styled from 'styled-components'
import { m as motion } from 'framer-motion'
import { media, Section } from './globalStyles'

export const ClientsSection = styled(Section)`
  .Scroller {
    width: 100%;
    height: calc(var(--vh, 1vh) * 100);
    ${media.lessThan('phone')`
      padding: 6rem 1.5625rem 0;
    `};
    & > div:last-child {
      background: ${(props) => props.theme.superLightGray};
    }
  }
`

export const ClientsWrapper = styled.div`
  display: grid;
  place-items: center;
  align-content: center;
  height: auto;
  min-height: 100%;
`

export const ClientsWrapperInner = styled.div`
  position: relative;
  padding-top: 5rem;
`

export const ClientsNav = styled(motion.div)`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  margin-bottom: 2.5rem;

  button {
    display: block;
    position: relative;
    padding-bottom: 0.75rem;
    font-size: 1.6875rem;
    line-height: 1.6875rem;
    font-weight: 300;
    text-transform: uppercase;
    margin: 0 2.5rem;
    ${media.lessThan('phone')`
      margin: 0 1.5rem;
    `};
    ${media.lessThan('miniPhone')`
      margin: 0 1rem;
    `};
    &::after {
      content: '';
      position: absolute;
      width: 100%;
      height: 0.1875rem;
      left: 0;
      bottom: 0;
    }
    ${media.greaterThan('phone')`
      &::after {
        transform: scaleX(0);
        transform-origin: right center;
        transition: all 300ms linear;
        transition-property: transform;
        will-change: transform;
        background: ${(props) => props.theme.blue};
      }
      &:hover,
      &.active {
        &::after {
          transform: scaleX(1);
          transform-origin: left center;
        }
      }
    `}
    ${media.lessThan('phone')`
      &.active {
        &::after {
          transform: scaleX(1);
          transform-origin: left center;
          background: ${(props) => props.theme.blue};
        }
      }
    `}
  }
`

export const ClientsSlider = styled(motion.div)`
  position: relative;
  width: 70%;
  ${media.lessThan('miniTablet')`
    width: 85%;
  `}
  ${media.lessThan('phone')`
    width: 100%;
  `}
`

export const ClientsSlide = styled(motion.div)`
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
`

export const SlideDescription = styled(motion.div)`
  padding: 0 20%;
  text-align: center;
  ${media.lessThan('tablet')`
    padding: 0 10%;
  `};
  ${media.lessThan('phone')`
    padding: 0 1.5rem;
  `};

  p {
    font-size: 1.375rem;
    line-height: 1.9375rem;
    letter-spacing: 0.02rem;
    margin-bottom: 2.5rem;
    &:last-child {
      margin: 0;
    }
  }
`

export const ClientItems = styled(motion.div)`
  position: relative;
  width: 100%;
  margin-top: 4rem;
  ${media.lessThan('phone')`
    margin-top: 0;
  `};
  .slick-slider {
    padding-bottom: 5rem;
    ${media.lessThan('tablet')`
      padding-bottom: 3.5rem;
    `};
     ${media.lessThan('phone')`
      margin-bottom: 15vh;
    `};
     ${media.lessThan('miniPhone')`
      margin-bottom: 8vh;
    `};
  }
  .slick-list {
    padding-bottom: 2rem;
    ${media.lessThan('phone')`
      padding: 0;
    `}
  }
  .slick-dots {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    display: flex !important;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;
    li {
      margin: 0 0.4375rem;
      button {
        width: 1rem;
        height: 1rem;
        padding: 0;
        font-size: 0;
        border-radius: 50%;
        opacity: 0.4;
        background: ${(props) => props.theme.blue};
        ${media.greaterThan('phone')`
          transition: background 300ms linear;
          will-change: background;
          &:hover {
            background: ${(props) => props.theme.darkBlue};
          }
        `}
      }
      &.slick-active {
        button {
          opacity: 1;
        }
      }
    }
  }
`

export const Item = styled(motion.div)`
  position: relative;
  flex-basis: 100%;
  height: 0;
  padding-top: 100%;
  button {
    position: absolute;
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    img {
      display: block;
      width: 60%;
      height: 43%;
      object-fit: contain;
    }
    h3 {
      position: absolute;
      left: 50%;
      top: 65%;
      font-size: 1.25rem;
      font-weight: 700;
      white-space: nowrap;
      opacity: 0;
    }
    ${media.greaterThan('phone')`
      h3 {
        transition: all 300ms ease-out;
        transition-property: opacity, transform;
        will-change: opacity, transform;
        transform: translate(-50%, 0);
      }
      img {
        transition: transform 300ms ease-out;
        will-change: transform;
      }
      &:hover {
        img {
          transform: scale(1.1);
        }
        h3 {
          opacity: 1;
          transform: translate(-50%, 3rem);
        }
      }
    `}
  }
  .aliados & {
    padding-top: 66.66666%;
    button {
      img {
        width: 75%;
      }
    }
  }
`

export const ClientModalWrapper = styled(motion.div)`
  position: fixed;
  width: 100vw;
  width: calc(var(--vw, 1vw) * 100);
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
  left: 0;
  top: 0;
  display: grid;
  place-items: center;
  background: ${(props) => props.theme.blackTransparent};
  z-index: 1000;
`

export const ClientModalContainer = styled(motion.div)`
  height: 100%;
  max-width: 40vw;
  max-width: calc(var(--vw, 1vw) * 50);
  min-height: 40vh;
  min-height: calc(var(--vh, 1vh) * 40);
  max-height: 75vh;
  max-height: calc(var(--vh, 1vh) * 75);
  border-radius: 1.5rem;
  background: white;
  overflow: hidden;

  ${media.lessThan('tablet')`
    max-width: 60vw;
    max-width: calc(var(--vw, 1vw) * 60);
  `};

  ${media.lessThan('miniTablet')`
    max-width: 80vw;
    max-width: calc(var(--vw, 1vw) * 80);
  `};

  ${media.lessThan('phone')`
    max-width: 90vw;
    max-width: calc(var(--vw, 1vw) * 90);
    min-height: 30vh;
    min-height: calc(var(--vh, 1vh) * 30);
    max-height: 70vh;
    max-height: calc(var(--vh, 1vh) * 70);
  `};

  .Scroller {
    width: 100%;
    height: 100%;
    & > div:last-child {
      background: ${(props) => props.theme.superLightGray};
    }
  }
`

export const ClientModalInner = styled.div`
  position: relative;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  height: auto;
  min-height: 100%;
  padding: 3.5rem 6rem 5rem;

  ${media.lessThan('phone')`
    display: block;
    padding: 3.5rem 2.1875rem;
  `};

  button {
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
    position: absolute;
    width: 2.5rem;
    height: 2.5rem;
    right: 1.5rem;
    top: 1.5rem;
    border-radius: 50%;
    background: ${(props) => props.theme.blue};
    svg {
      width: 45%;
      fill: white;
    }
    ${media.greaterThan('phone')`
      transition: background 300ms linear;
      will-change: background;
      &:hover {
        background: ${(props) => props.theme.orange};
      }
    `}
  }

  h3 {
    font-size: 2.5rem;
    font-weight: 500;
    text-align: center;
    text-transform: capitalize;
    margin: 2.5rem 0;
    ${media.lessThan('phone')`
      margin: 2rem 0;
    `};
  }

  &.awards {
    button {
      background: ${(props) => props.theme.green};
      ${media.greaterThan('phone')`
        &:hover {
          background: ${(props) => props.theme.orange};
        }
      `}
    }
  }
`

export const ClientModalLogo = styled.span`
  display: block;
  position: relative;
  width: 70%;
  height: 0;
  padding-top: 15%;
  margin: 0 auto;
  img {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  ${media.lessThan('phone')`
    padding-top: 30%;
  `}
  .awards & {
    width: 55%;
    padding-top: 25%;
  }
`

export const ClientModalDesc = styled.div`
  text-align: center;
  p {
    font-size: 1.25rem;
    line-height: 1.6875rem;
    font-weight: 300;
    margin: 0 0 2.5rem;
    &:last-child {
      margin: 0;
    }

    a {
      color: ${(props) => props.theme.blue};
      ${media.greaterThan('phone')`
        &:hover {
          color: ${(props) => props.theme.darkBlue};
        }
      `}
    }
  }
`